import { DeliveriesTracking } from '../models/deliveriesTracking';
import { DeliveryTrackingDto } from '../dtos/deliveriesTracking';

export function dtoToDeliveriesTracking(deliveriesTracking: DeliveryTrackingDto[]): DeliveriesTracking {
  if (!deliveriesTracking) {
    return {};
  }
  return deliveriesTracking.reduce((obj, item) => {
    const driverLocationDetails = item.driver_location_details && {
      lat: item.driver_location_details.latitude,
      lng: item.driver_location_details.longitude
    };
    obj[item.booking_id] = { eta: item.eta, driverLocationDetails: driverLocationDetails };
    return obj;
  }, {} as DeliveriesTracking);
}
